var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreMeasurements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear_3339_10937)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6552 22.7317L28.4832 25.5607L24.9482 29.0957L11.5131 15.6607L15.0482 12.1247L17.1692 14.2467L15.7552 15.6607L17.1692 17.0747L18.5842 15.6607L20.7052 17.7817L18.5842 19.9037L19.9982 21.3177L22.1182 19.1967L24.2402 21.3167L22.8252 22.7317L24.2402 24.1457L25.6552 22.7317ZM14.3412 10.0037L9.39115 14.9537C9.20368 15.1413 9.09837 15.3956 9.09837 15.6607C9.09837 15.9259 9.20368 16.1802 9.39115 16.3677L24.2412 31.2177C24.4287 31.4052 24.683 31.5105 24.9482 31.5105C25.2133 31.5105 25.4676 31.4052 25.6552 31.2177L30.6052 26.2677C30.6981 26.1749 30.7719 26.0646 30.8222 25.9432C30.8725 25.8218 30.8984 25.6916 30.8984 25.5602C30.8984 25.4288 30.8725 25.2987 30.8222 25.1773C30.7719 25.0559 30.6981 24.9456 30.6052 24.8527L15.7552 10.0037C15.5676 9.81625 15.3133 9.71094 15.0482 9.71094C14.783 9.71094 14.5287 9.81625 14.3412 10.0037Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3339_10937",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMeasurements);
export default __webpack_public_path__ + "static/media/More Measurements.1317d4b83bb6185856c6f33a9b81bc03.svg";
export { ForwardRef as ReactComponent };